import { Table, TableContainer, TableHead, TableRow, TableCell, TableSortLabel, TableBody, Tooltip, IconButton, Button, Collapse, Box, Modal, Divider } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Alert from "@material-ui/lab/Alert";
import { toast } from 'react-toastify';
import { tokenValidation } from '../../../helper/customizedHooks';
import base from '../../../config';
import Axios from 'axios';
import styled, { css } from "styled-components";
import LoadingOverlay from "react-loading-overlay";



/**
 * @author Poornna Aiswarya Ganeshan
 * @version 1.0
 * @see Used in component: Admin
 * @description Displays table of stuck orders
 */

// const useStyles = makeStyles(theme => ({
//     paper: {
//         position: "absolute",
//         width: "100%",
//         backgroundColor: theme.palette.background.paper,
//         // boxShadow: theme.shadows[5],
//         boxShadow: "unset",
//         padding: "15px 32px 32px 32px"
//     },
//     count: {
//         margin: '0 0 0 0.3em',
//         color: '#ffffff',
//         margin: '0 0 0 0.3em',
//         fontSize: '1.2rem',
//         background: '#7500c0',
//         padding: '0rem 0.7rem 0.2rem 0.7rem',
//         borderRadius: '3rem',
//     },
//     root: {
//         width: '100%',
//         '& > * + *': {
//             marginTop: theme.spacing(2),
//         },
//     },
//     editModal: {
//         position: "absolute",
//         width: "50%",
//         backgroundColor: theme.palette.background.paper,
//         // boxShadow: theme.shadows[5],
//         boxShadow: "unset",
//         padding: "15px 32px 32px 32px"
//     },
//     status: {
//         display: 'inline-block',
//         padding: '2px 10px',
//         borderRadius: '20px',
//         fontWeight: 750,
//         fontSize: '14px',
//         fontFamily: 'sans-serif',
//         textTransform: 'uppercase',
//         // color: '#fff',
//         '&::before': {
//             fontSize: '15px',
//         },
//     },
//     pending: {
//         backgroundColor: '#FCCAAC',
//         color: '#FF7518',
//     },
//     approved: {
//         backgroundColor: '#BCF5A6',
//         color: '#61DE2A',
//     },
//     declined: {
//         backgroundColor: '#F08080',
//         color: '#FE001A'
//     },
//     row: {
//         backgroundColor: '#fff',
//         borderRadius: 12,
//         transition: 'background-color 0.3s, color 0.3s, transform 0.2s, box-shadow 0.2s',
//         cursor: 'pointer',
//         '&:hover': {
//             // backgroundColor: '#f0e6ff',
//             backgroundColor: '#F7EBFF',
//             transform: 'translateY(-4px)',
//             boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
//         },
//     },
//     sectionCard: {
//         flex: 1,
//         padding: theme.spacing(2),
//         backgroundColor: '#ffffff',
//         borderRadius: '8px',
//         boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//         border: '1px solid #e0e0e0',
//     },
//     sectionTitle: {
//         fontWeight: 600,
//         marginBottom: theme.spacing(1),
//         color: '#333',
//     },
//     expandedSection: {
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         gap: theme.spacing(2),
//         padding: theme.spacing(2),
//         backgroundColor: '#fafafa',
//         borderTop: `1px solid #e0e0e0`,
//     },
//     headerCell: {
//         fontWeight: 600,
//         background: '#7500C0',
//         top: 0,
//         position: 'sticky',
//         zIndex: 2,
//     },
//     headerItem: {
//         color: "#fff",
//         padding: "12px",
//         // '&:hover': { backgroundColor: "#D1B3FF", border: '1px solid #e0e0e0' },
//         '&:hover': {
//             "backgroundColor": "#A04DDA",
//             "color": " #FFFFFF",
//             "transition": "backgroundColor 0.3s ease, color 0.3s ease",
//             "cursor": "pointer"
//         }
//     }
// }));

const useStyles = makeStyles(theme => ({
    paper: {
        position: "absolute",
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        boxShadow: "unset",
        padding: "15px 32px 32px 32px"
    },
    count: {
        color: '#ffffff',
        fontSize: '1.2rem',
        background: '#7500c0',
        padding: '0rem 0.7rem 0.2rem 0.7rem',
        borderRadius: '3rem',
        margin: '0 0 0 0.3em',
    },
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    editModal: {
        position: "absolute",
        width: "50%",
        backgroundColor: theme.palette.background.paper,
        boxShadow: "unset",
        padding: "15px 32px 32px 32px"
    },

    // 💡 Status Badge Styling
    status: {
        display: 'inline-block',
        padding: '4px 12px',
        borderRadius: '20px',
        fontWeight: 600,
        fontSize: '0.75rem',
        fontFamily: 'sans-serif',
        textTransform: 'uppercase',
    },
    pending: {
        backgroundColor: '#FCCAAC',
        color: '#FF7518',
    },
    approved: {
        backgroundColor: '#BCF5A6',
        color: '#61DE2A',
    },
    declined: {
        backgroundColor: '#F08080',
        color: '#FE001A',
    },

    // 🧾 Table Row Hover
    row: {
        backgroundColor: '#fff',
        borderRadius: 12,
        transition: 'background-color 0.3s, color 0.3s, transform 0.2s, box-shadow 0.2s',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#F7EBFF',
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        },
    },

    // 📄 Section Cards
    sectionCard: {
        flex: 1,
        padding: theme.spacing(2),
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '1px solid #e0e0e0',
    },
    sectionTitle: {
        fontWeight: 600,
        marginBottom: theme.spacing(1),
        color: '#333',
    },
    expandedSection: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: '#fafafa',
        borderTop: `1px solid #e0e0e0`,
    },

    // 🧭 Header Styling
    headerCell: {
        fontWeight: 600,
        backgroundColor: '#7500C0',
        top: 0,
        position: 'sticky',
        zIndex: 2,
    },
    headerItem: {
        color: "#fff",
        padding: "12px",
        '&:hover': {
            backgroundColor: "#A04DDA",
            color: "#FFFFFF",
            transition: "background-color 0.3s ease, color 0.3s ease",
            cursor: "pointer"
        },
    },
    sortButton: {
        backgroundColor: 'black',
        border: 'none',
        color: 'white',
        marginLeft: theme.spacing(0.5),
        cursor: 'pointer',
        fontSize: '0.8rem',
        padding: 0,
    },
    tableCell: {
        padding: '14px 16px',
        fontSize: '0.88rem',
        color: '#333',
        borderBottom: '1px solid #e0e0e0',
    },
    actionBtn: {
        background: '#7500C0',
        fontSize: '12px',
        cursor: 'pointer',
        color: "#FFF",
        '&:hover': {
            borderColor: "#7500C0",
            // backgroundColor: "#A04DDA",
            color: "#7500C0",
            transition: "background-color 0.3s ease, color 0.3s ease",
            cursor: "pointer"
        },
    }

    // style={{ borderColor: "#7500C0", color: "#7500C0" }}
    // style={{ background: "#7500C0", color: "#FFF" }}


}));

const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
        props.disappear &&
        css`
      display: block; /* show */
    `}
`;

function getModalStyle() {
    const top = 50;
    const left = 50;
    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`
    };
}


const OrdersAdminPageData = (props) => {
    const {
        stuckOrdersList,
        email,
        idToken,
        page,
        rowsPerPage,
    } = props;
    const [loaded, setLoaded] = useState(true);
    const classes = useStyles();
    const [open, setOpen] = useState(-1);
    const [selectedRowData, setSelectedRowData] = useState(" ");
    const [openActionModal, setOpenActionModal] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
    const [modalStyle] = React.useState(getModalStyle);

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
        setSortConfig({ key, direction });
    };

    // const sortedData = stuckOrdersList.sort((a, b) => {
    //     if (!sortConfig.key) return 0;
    //     const aValue = (a[sortConfig.key] || "").toLowerCase();
    //     const bValue = (b[sortConfig.key] || "").toLowerCase();
    //     if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
    //     if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
    //     return 0;
    // });

    const sortedData = React.useMemo(() => {
        if (!sortConfig.key) return stuckOrdersList;

        return [...stuckOrdersList].sort((a, b) => {
            const aValue = a[sortConfig.key];
            const bValue = b[sortConfig.key];

            const valA = typeof aValue === 'string' ? aValue.toLowerCase() : aValue;
            const valB = typeof bValue === 'string' ? bValue.toLowerCase() : bValue;

            if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
            if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
            return 0;
        });

    }, [stuckOrdersList, sortConfig]);

    const handleClose = () => {
        setOpenActionModal(false);
    }

    const handleOpenActionsMenu = (event, row) => {
        setOpenActionModal(true);
        setSelectedRowData(row);
    };

    const handleOrderReplay = () => {
        tokenValidation();
        const idToken = localStorage.getItem("token");
        // const environment = selectedRowData.OrderItems[0].Config.find(item => item.Key === "Environment")['Value']
        const orderItemUId = selectedRowData.OrderItems[0].OrderItemUId
        const urls = `${base.urls.apis.fulfillment}/failedorders/replay`;
        Axios.post(urls, "", {
            headers: { "Content-Type": "application/json", Authorization: idToken },
            params: {
                orderId: orderItemUId,
                environment: "prod"
            },
        }).then((res) => {
            setLoaded(true);
            toast.info("Order replay is initiated. Thank you for actioning on it!")
        })
            .catch((err) => {
                toast.error("ERROR! Please try again after sometime.");
                setLoaded(true);
                console.log("Async error", err);
            });
        handleClose();
        setLoaded(false);
    };

    return (
        <>
            <div>
                <DarkBackground disappear={!loaded}>
                    <LoadingOverlay
                        active={true}
                        // spinner={<BounceLoader />}
                        spinner={true}
                    >
                        {/* <p>Some content or children or something.</p> */}
                    </LoadingOverlay>
                </DarkBackground>
                {/* Stuck Orders - Table Contents */}
                <TableContainer className={classes.root}>
                    <Table stickyHeader>
                        <TableHead className={classes.headerCell}>
                            <TableRow>
                                {["Order ID", "Ordered Date", "Domain Contex Root", "Product Name", "WBSE Code", "Order Type", "Request Notes", "Customer Enterprise ID", "Action"].map((col) => (
                                    <TableCell key={col} className={`${classes.headerCell} ${classes.headerItem}`}>
                                        {/* <TableSortLabel
                                        active={sortConfig.key === col}
                                        direction={sortConfig.direction}
                                        onClick={() => handleSort(col)}
                                    >
                                        {col}
                                    </TableSortLabel> */}
                                        {col}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        {sortedData
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => (
                                <TableBody>
                                    <TableRow className={classes.row}>
                                        {/* <TableCell>
                                        <Tooltip title="View Details">
                                            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(open === index ? -1 : index)}>
                                                {open === index ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell> */}
                                        <TableCell component="th" scope="row" style={{ padding: "12px", fontWeight: "500" }} onClick={() => setOpen(open === index ? -1 : index)}>
                                            {row.OrderItems[0].OrderItemUId}
                                        </TableCell>
                                        <TableCell component="th" scope="row" style={{ padding: "12px" }} onClick={() => setOpen(open === index ? -1 : index)}>
                                            {row.OrderItems[0].CreatedDate ? row.OrderItems[0].CreatedDate.split("T")[0] : row.OrderItems[0].CreateDate.split("T")[0]}
                                        </TableCell>
                                        <TableCell align="left" style={{ padding: "12px" }} onClick={() => setOpen(open === index ? -1 : index)}>
                                            {row.OrderItems[0].Config.find(item => item.Key === "DomainContextRoot")['Value']}
                                        </TableCell>
                                        <TableCell align="left" style={{ padding: "12px" }} onClick={() => setOpen(open === index ? -1 : index)}>
                                            {
                                                row.OrderItems[0].Config.find(item => item.Key === "AaamPlatformType")['Value'].includes("myWizard AiOps")
                                                    ? row.OrderItems[0].Config.find(item => item.Key === "AaamPlatformType")['Value'].replace('myWizard AiOps', '')
                                                    : row.OrderItems[0].Config.find(item => item.Key === "AaamPlatformType")['Value']
                                            }
                                        </TableCell>
                                        <TableCell align="left" style={{ padding: "12px" }} onClick={() => setOpen(open === index ? -1 : index)}>
                                            {row.OrderItems[0].Config.find(item => item.Key === "WBSEcode")['Value']}
                                        </TableCell>
                                        <TableCell align="left" style={{ padding: "12px" }} onClick={() => setOpen(open === index ? -1 : index)}>
                                            {row.OrderItems[0].Config.find(item => item.Key === "ConfigurationType")['Value'] === "full" ? "Client" : "Internal"}
                                        </TableCell>
                                        <Tooltip title={row.OrderItems[0].Config.find(item => item.Key === "RequestNotes")['Value']} >
                                            <TableCell align="left" style={{ padding: "12px" }} onClick={() => setOpen(open === index ? -1 : index)}>
                                                {row.OrderItems[0].Config.find(item => item.Key === "RequestNotes")['Value'].slice(0, 15)}...
                                            </TableCell>
                                        </Tooltip>
                                        {/* <TableCell align="left" style={{ padding: "12px" }}>
                                                    {row.OrderItems[0].Config.find(item => item.Key === "RequestNotes")['Value']}
                                                </TableCell> */}
                                        <TableCell align="left" style={{ padding: "12px", fontWeight: "500" }} onClick={() => setOpen(open === index ? -1 : index)}>
                                            {row.OrderItems[0].Config.find(item => item.Key === "CustomerEnterpriseID")['Value']}
                                        </TableCell>
                                        {/* <TableCell align="left" style={{ padding: "12px" }} onClick={() => setOpen(open === index ? -1 : index)}>
                                        {
                                            row.OrderItems[0].Config.find(item => item.Key === "ApprovalStatus")['Value'] === "Pending Approval" ?
                                                <span className={`${classes.status} ${classes.pending}`}>Pending</span>
                                                :
                                                row.OrderItems[0].Config.find(item => item.Key === "ApprovalStatus")['Value'] === "Approved" ?
                                                    <span className={`${classes.status} ${classes.approved}`}>Approved</span>
                                                    :
                                                    row.OrderItems[0].Config.find(item => item.Key === "ApprovalStatus")['Value'] === "Declined" ?
                                                        <span className={`${classes.status} ${classes.declined}`}>Declined</span>
                                                        : ""
                                        }
                                    </TableCell> */}
                                        <TableCell align="left" style={{ padding: "12px" }} >
                                            <div style={{ display: "flex" }}>
                                                <Button
                                                    // style={{ color: "black" }}
                                                    className={classes.actionBtn}
                                                    onClick={(event) => handleOpenActionsMenu(event, row)}
                                                >
                                                    {/* <MoreVertIcon /> */}
                                                    Replay
                                                </Button>&nbsp;&nbsp;
                                            </div>
                                        </TableCell>
                                    </TableRow>

                                    {/* Expanded Section with more details */}
                                    <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                                            <Collapse in={open === index} timeout="auto" unmountOnExit>
                                                <Box className={classes.expandedSection} style={{ padding: "1% 3% 0% 3%" }}>
                                                    <Table aria-label="purchases">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell className={classes.sectionTitle}>Client & Contract Details </TableCell>
                                                                <TableCell className={classes.sectionTitle}>Environment Details</TableCell>
                                                                <TableCell className={classes.sectionTitle}>Application Configuration Details</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell className={classes.sectionCard} component="th" scope="row" style={{ lineHeight: "7px" }}>
                                                                    <p>
                                                                        <span style={{ fontWeight: 600 }}>SAP Contract ID:</span>{" "}
                                                                        {
                                                                            (() => {
                                                                                const config = row.OrderItems[0].Config;
                                                                                const sapItem = config.find(item =>
                                                                                    item.Key === "SAPContractID" || item.Key === "SAPContractId"
                                                                                );
                                                                                return sapItem.Value;
                                                                            })()
                                                                        }
                                                                    </p>
                                                                    <p><span style={{ fontWeight: 600 }}>End To End UID:</span> {row.OrderItems[0].Config.find(item => item.Key === "EndToEndUId")['Value']}</p>
                                                                    <p><span style={{ fontWeight: 600 }}>WBSE Code:</span> {row.OrderItems[0].Config.find(item => item.Key === "WBSEcode")['Value'] == "" ? "NA" : row.OrderItems[0].Config.find(item => item.Key === "WBSEcode")['Value']}</p>
                                                                    <p><span style={{ fontWeight: 600 }}>Project Name:</span> {row.OrderItems[0].Config.find(item => item.Key === "ProjectName")['Value']}</p>
                                                                    <p><span style={{ fontWeight: 600 }}>CR/RITM Number:</span> {row.OrderItems[0].Config.find(item => item.Key === "RITM")['Value'] == "" ? "NA" : row.OrderItems[0].Config.find(item => item.Key === "RITM")['Value']}</p>
                                                                </TableCell>
                                                                <TableCell className={classes.sectionCard} component="th" scope="row" style={{ lineHeight: "7px" }}>
                                                                    <p><span style={{ fontWeight: 600 }}>Domain Context Root:</span> {row.OrderItems[0].Config.find(item => item.Key === "DomainContextRoot")['Value']}</p>
                                                                    <p><span style={{ fontWeight: 600 }}>Deployment Region:</span> {row.OrderItems[0].Config.find(item => item.Key === "DeploymentRegion")['Value']}</p>
                                                                    <p><span style={{ fontWeight: 600 }}>Environment:</span> {row.OrderItems[0].Config.find(item => item.Key === "Environment")['Value']}</p>
                                                                    <p><span style={{ fontWeight: 600 }}>Tier:</span> {row.OrderItems[0].Config.find(item => item.Key === "Tier")['Value'] == "" ? "NA" : row.OrderItems[0].Config.find(item => item.Key === "Tier")['Value']}</p>
                                                                </TableCell>
                                                                <TableCell className={classes.sectionCard} component="th" scope="row" style={{ lineHeight: "7px" }}>
                                                                    <p><span style={{ fontWeight: 600 }}>Tentative Service End Date:</span> {row.OrderItems[0].Config.find(item => item.Key === "TentativeServiceEndDate")['Value'].split("T")[0]}</p>
                                                                    <p><span style={{ fontWeight: 600 }}>Enable GenAI:</span> {row.OrderItems[0].Config.find(item => item.Key === "OpenAI")['Value']}</p>
                                                                    <p><span style={{ fontWeight: 600 }}>Instance Type:</span> {row.OrderItems[0].Config.find(item => item.Key === "InstanceType")['Value']}</p>
                                                                    {/* <p><span style={{ fontWeight: 600 }}>Admin Distribution Group:</span> {row.OrderItems[0].Config.find(item => item.Key === "AdminDistributionGroup")['Value']}</p> */}
                                                                    {(() => {
                                                                        const adminGroupItem = row.OrderItems[0].Config.find(item => item.Key === "AdminDistributionGroup");
                                                                        return adminGroupItem ? (
                                                                            <p>
                                                                                <span style={{ fontWeight: 600 }}>Admin Distribution Group:</span> {adminGroupItem.Value}
                                                                            </p>
                                                                        ) : null;
                                                                    })()}

                                                                    <p><span style={{ fontWeight: 600 }}>Request Notes:</span> {row.OrderItems[0].Config.find(item => item.Key === "RequestNotes")['Value']}</p>
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </Box>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            ))}
                    </Table>
                </TableContainer>
            </div>
            {/* Replay confirmation pop-up */}
            <Modal open={openActionModal} onClose={handleClose}>
                <div style={modalStyle} className={classes.editModal}>
                    <div>
                        <h3 style={{ color: "#7500C0" }}>Replay Order</h3>
                        <Divider />
                        {/* <br></br> */}
                        {/* <div className={classes.root}> */}
                        {/* <div>
                            <Alert severity="info">Monthly recovery for Infra provisioned for this order will be billed to the below mentioned WBSE.</Alert>
                        </div> */}
                        {/* <br></br> */}
                        {/* <div style={{ lineHeight: "7px" }}> */}
                        {/* <div> */}
                        {/* <p><span style={{ fontWeight: 500 }}>Order ID:</span> {selectedRowData.OrderItems[0].OrderItemUId}</p>
                            <p><span style={{ fontWeight: 500 }}>Client Name:</span> {selectedRowData.ClientName === "myWizard AiOps" ? "GenWizard AiOps" : selectedRowData.ClientName}</p>
                            <p><span style={{ fontWeight: 500 }}>WBSE Code:</span> {selectedRowData.OrderItems[0].Config.find(item => item.Key === "WBSEcode")['Value'] == "" ? "NA" : selectedRowData.OrderItems[0].Config.find(item => item.Key === "WBSEcode")['Value']}</p> */}
                        {/* </div> */}
                        <p><br></br>Are you sure you want to <b>replay</b> this order now?</p>
                        <div style={{ float: "right" }}>
                            <Button
                                variant="outlined"
                                style={{ borderColor: "#7500C0", color: "#7500C0" }}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>&nbsp;
                            <Button
                                style={{ background: "#7500C0", color: "#FFF" }}
                                onClick={handleOrderReplay}
                            >
                                Yes, Replay
                            </Button>

                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default OrdersAdminPageData